import Big from "big.js";

// Extend Big interface to override toJSON return type
declare module "big.js" {
  interface Big {
    toJSON(): number;
  }
}

/**
 * Extend Big.js prototype to properly serialize to JSON
 * This ensures Big numbers are converted to regular numbers with 2 decimal places
 * when stringified via JSON.stringify()
 */
Big.prototype.toJSON = function (): number {
  return parseFloat(this.toFixed(2));
};
